<template>
  <div>
    <button
      :class="cssClass + ' margin-horizontal-3'"
      @click="clicked"
      :data-toggle="tooltip ? 'tooltip' : ''"
      :data-placement="tooltip ? 'bottom' : ''"
      :title="tooltip"
    >
      <i v-if="buttonIcon" :class="buttonIcon"></i>
      <img v-if="imgUrl" :src="imgUrl" alt="icon" />
      {{ text }}
    </button>
  </div>
</template>
<script>
export default {
  name: "br-button",
  props: {
    text: {
      type: String,
      default: "",
      description: "",
    },
    buttonIcon: {
      type: String,
      default: "",
      description: "",
    },
    cssClass: {
      type: String,
      default: "No Text",
      description: "",
    },
    imgUrl: {
      type: String,
      description: "Image Button",
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {
    clicked() {
      this.$emit("clicked");
    },
  },
};
</script>
